import { createReducer, on } from '@ngrx/store';
import { setQuote, setCurrentStep, addToPrevious } from './quote.actions';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';

const localStorageService = new LocalStorageService();

export interface State {
  quote; // Quote; TODO: crear modelo de Quote
}

export const initialState = localStorageService.get('currentQuote') || {};

export const quoteReducer = createReducer(
  initialState,

  on(setQuote, (state, { quote }) => ({ ...quote })),
  on(setCurrentStep, (state, { currentStep }) => ({ ...state, currentStep })),
  on(addToPrevious, (state) => ({ ...state, toPrevious: true }))
);
